import React from 'react';
import { createPortal } from 'react-dom';
import CustomButton from '../OnboardingComponents/CustomButton';

const DeleteConfirmation = ({
  isOpen,
  onCancel,
  onConfirm,
  title = 'Delete Project',
  message = 'Are you sure you want to delete this project? This action cannot be undone. All associated task logs and collaborators will be removed.',
  cancelText = 'Cancel',
  confirmText = 'Delete Project',
  confirmLoadingText = 'Deleting...',
  isDeleting = false,
  className = '',
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className={['delete-confirmation', className].filter(Boolean).join(' ')}
      onClick={onCancel}
    >
      <div
        className="delete-confirmation__content"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="delete-confirmation__title">{title}</h3>
        <p className="delete-confirmation__message">{message}</p>
        <div className="delete-confirmation__actions">
          <CustomButton
            size="md"
            onClick={onCancel}
            disabled={isDeleting}
            style={{ backgroundColor: '#F0F0F0', color: '#6E6E6E' }}
          >
            {cancelText}
          </CustomButton>
          <CustomButton
            size="md"
            onClick={onConfirm}
            disabled={isDeleting}
            style={{ backgroundColor: '#9B0000', color: '#FFFFFF' }}
          >
            {isDeleting ? confirmLoadingText : confirmText}
          </CustomButton>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmation;
